module.exports = __webpack_public_path__ + "static/media/7news-gallery.595021c2.svg";